/* ---------------------------
   custom.js — Vanilla JS
----------------------------*/

document.addEventListener('DOMContentLoaded', () => {
  /* ---------------------------
   Helpers
  ----------------------------*/
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const $1 = (sel, ctx = document) => ctx.querySelector(sel);

  // slideUp/Down/Toggle (CSS transition based)
  function slideUp(el, duration = 200) {
    if (!el) return;
    el.style.height = el.offsetHeight + 'px';
    el.offsetHeight; // force reflow
    el.style.transitionProperty = 'height, margin, padding';
    el.style.transitionDuration = `${duration}ms`;
    el.style.overflow = 'hidden';
    el.style.height = 0;
    el.style.paddingTop = 0;
    el.style.paddingBottom = 0;
    el.style.marginTop = 0;
    el.style.marginBottom = 0;
    window.setTimeout(() => {
      el.style.display = 'none';
      el.style.removeProperty('height');
      el.style.removeProperty('padding-top');
      el.style.removeProperty('padding-bottom');
      el.style.removeProperty('margin-top');
      el.style.removeProperty('margin-bottom');
      el.style.removeProperty('overflow');
      el.style.removeProperty('transition-duration');
      el.style.removeProperty('transition-property');
    }, duration);
  }

  function slideDown(el, duration = 200) {
    if (!el) return;
    el.style.removeProperty('display');
    let display = window.getComputedStyle(el).display;
    if (display === 'none') display = 'block';
    el.style.display = display;

    const height = el.offsetHeight;
    el.style.overflow = 'hidden';
    el.style.height = 0;
    el.style.paddingTop = 0;
    el.style.paddingBottom = 0;
    el.style.marginTop = 0;
    el.style.marginBottom = 0;
    el.offsetHeight; // force reflow
    el.style.transitionProperty = 'height, margin, padding';
    el.style.transitionDuration = `${duration}ms`;
    el.style.height = height + 'px';
    el.style.removeProperty('padding-top');
    el.style.removeProperty('padding-bottom');
    el.style.removeProperty('margin-top');
    el.style.removeProperty('margin-bottom');
    window.setTimeout(() => {
      el.style.removeProperty('height');
      el.style.removeProperty('overflow');
      el.style.removeProperty('transition-duration');
      el.style.removeProperty('transition-property');
    }, duration);
  }

  function isHidden(el) {
    return !el || window.getComputedStyle(el).display === 'none';
  }

  function slideToggle(el, duration = 200) {
    if (!el) return;
    isHidden(el) ? slideDown(el, duration) : slideUp(el, duration);
  }

  // get siblings of an element
  function siblings(el) {
    return Array.from(el.parentElement?.children || []).filter((c) => c !== el);
  }

  /* ----------------------------------------------------
   .menu-grid h4 click -> toggle all siblings (slide)
  -----------------------------------------------------*/
  $$('.menu-grid h4').forEach((h4) => {
    h4.addEventListener('click', () => {
      siblings(h4).forEach((sib) => slideToggle(sib, 200));
      h4.classList.toggle('active');
    });
  });

  /* ---------------------------------------------
   Slick initializations (guarded)
   If jQuery + Slick exist, run them; otherwise skip
  ----------------------------------------------*/
  const hasJQ = !!window.jQuery;
  const hasSlick = hasJQ && typeof window.jQuery.fn?.slick === 'function';

  // .feature-blog__list slider
  if (hasSlick) {
    window.jQuery('.feature-blog__list').slick({
      arrows: true,
      dots: false,
      slidesToShow: 4,
      unslick: true,
      slidesToScroll: 1,
      infinite: false,
      responsive: [
        { breakpoint: 992, settings: { slidesToShow: 3 } },
        { breakpoint: 768, settings: { slidesToShow: 2 } },
      ],
    });
  }

  /* ------------------------------- 
   Variant panels toggle (radios)
  --------------------------------*/
  // delegate: listens for changes on all variant-radios
  document.addEventListener('change', (e) => {
    const input = e.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (input.type !== 'radio') return;
    const radiosRoot = input.closest('variant-radios');
    if (!radiosRoot) return;

    // Panels are siblings of the radio under the same immediate parent in your jQuery
    const parent = input.parentElement || radiosRoot;

    const spring = parent.querySelector('.custom_spring_center_variant');
    const camber = parent.querySelector('.cambered_axle_tube_variant');
    const full = parent.querySelector('.fully_custom_variant');

    const disclaimerWrap = $1('#disclaimer-container');
    const disclaimerInput = $1('#custom-disclaimer');

    // Helpers that scope queries to the panel passed in
    const enableSpringPanel = () => {
      spring?.classList.add('custom-slide-active');
      camber?.classList.remove('custom-slide-active');
      full?.classList.remove('custom-slide-active');

      spring?.querySelector('#hubface-selection') && (spring.querySelector('#hubface-selection').disabled = false);
      const sc = spring?.querySelector('#custom-spring-center');
      if (sc) {
        sc.disabled = false;
        sc.required = true;
      }
      const springTube = spring?.querySelector('#cambered-axle-tube-spring');
      if (springTube) springTube.disabled = false;

      // disable others
      camber?.querySelectorAll('#hubface-selection, #cambered-axle-tube-spring')
        .forEach((el) => { el.disabled = true; el.required = false; });
      full?.querySelectorAll('#custom-hubface, #custom-spring-center-fully, #cambered-axle-tube-custom')
        .forEach((el) => { el.disabled = true; el.required = false; });

      if (disclaimerWrap) disclaimerWrap.style.display = 'block';
      if (disclaimerInput) disclaimerInput.required = true;
    };

    const enableCamberPanel = () => {
      camber?.classList.add('custom-slide-active');
      spring?.classList.remove('custom-slide-active');
      full?.classList.remove('custom-slide-active');

      camber?.querySelector('#hubface-selection') && (camber.querySelector('#hubface-selection').disabled = false);
      const camberTube = camber?.querySelector('#cambered-axle-tube-spring');
      if (camberTube) camberTube.disabled = false;

      spring?.querySelectorAll('#hubface-selection, #custom-spring-center, #cambered-axle-tube-spring')
        .forEach((el) => { el.disabled = true; el.required = false; });
      full?.querySelectorAll('#custom-hubface, #custom-spring-center-fully, #cambered-axle-tube-custom')
        .forEach((el) => { el.disabled = true; el.required = false; });

      if (disclaimerWrap) disclaimerWrap.style.display = 'block';
      if (disclaimerInput) disclaimerInput.required = true;
    };

    const enableFullyCustomPanel = () => {
      full?.classList.add('custom-slide-active');
      spring?.classList.remove('custom-slide-active');
      camber?.classList.remove('custom-slide-active');

      const hf = full?.querySelector('#custom-hubface');
      if (hf) { hf.disabled = false; hf.required = true; }
      const scf = full?.querySelector('#custom-spring-center-fully');
      if (scf) scf.disabled = false;
      const catc = full?.querySelector('#cambered-axle-tube-custom');
      if (catc) catc.disabled = false;

      spring?.querySelectorAll('#hubface-selection, #custom-spring-center, #cambered-axle-tube-spring')
        .forEach((el) => { el.disabled = true; el.required = false; });
      camber?.querySelectorAll('#hubface-selection, #cambered-axle-tube-spring')
        .forEach((el) => { el.disabled = true; el.required = false; });

      if (disclaimerWrap) disclaimerWrap.style.display = 'block';
      if (disclaimerInput) disclaimerInput.required = true;
    };

    const resetAll = () => {
      spring?.classList.remove('custom-slide-active');
      spring?.querySelectorAll('#hubface-selection, #custom-spring-center, #cambered-axle-tube-spring')
        .forEach((el) => { el.disabled = true; el.required = false; });

      camber?.classList.remove('custom-slide-active');
      camber?.querySelectorAll('#hubface-selection, #cambered-axle-tube-spring')
        .forEach((el) => { el.disabled = true; el.required = false; });

      full?.classList.remove('custom-slide-active');
      full?.querySelectorAll('#custom-hubface, #custom-spring-center-fully, #cambered-axle-tube-custom')
        .forEach((el) => { el.disabled = true; el.required = false; });

      if (disclaimerWrap) disclaimerWrap.style.display = 'none';
      if (disclaimerInput) { disclaimerInput.required = false; disclaimerInput.checked = false; }
    };

    // Branches that match your 3 variant titles
    const checkedSpringCenter = radiosRoot.querySelector('input[type="radio"][value*="Custom Spring Center"]:checked');
    const checkedCamberedTube = radiosRoot.querySelector('input[type="radio"][value*="Cambered Axle Tube"]:checked');
    const checkedAnyCustom = radiosRoot.querySelector('input[type="radio"][value*="Custom"]:checked');

    if (checkedSpringCenter) {
      enableSpringPanel();
    } else if (checkedCamberedTube) {
      enableCamberPanel();
    } else if (checkedAnyCustom && !radiosRoot.querySelector('input[type="radio"][value*="Custom Spring Center"]:checked')) {
      // Any "Custom" that is NOT "Custom Spring Center"
      enableFullyCustomPanel();
    } else {
      resetAll();
    }
  });

  /* ------------------------------------------------
   Blog filter slider (guarded for jQuery Slick)
  -------------------------------------------------*/
  if (hasSlick) {
    window.jQuery('.blog-filter').slick({
      arrows: true,
      dots: false,
      slidesToShow: 6,
      unslick: true,
      slidesToScroll: 1,
      infinite: false,
      responsive: [
        { breakpoint: 992, settings: { slidesToShow: 3 } },
        { breakpoint: 768, settings: { slidesToShow: 2 } },
        { breakpoint: 400, settings: { slidesToShow: 1 } },
      ],
    });

    // go to active button's index if present
    const activeBtn = document.querySelector('.custom-btn.active');
    const idx = activeBtn?.dataset?.slickIndex;
    if (typeof idx !== 'undefined') {
      window.jQuery('.blog-filter').slick('slickGoTo', idx);
    }
  }

  /* ------------------------------------------------
   Ensure correct panel is active on initial load
  -------------------------------------------------*/
  const initiallyChecked = document.querySelector('variant-radios input[type="radio"]:checked');
  if (initiallyChecked) {
    // fire a native change event
    initiallyChecked.dispatchEvent(new Event('change', { bubbles: true }));
  }
});


